<template>
	<div class="wrapper-status text-xs-center">
		<img src="/static/images/icons/checked-1.svg" alt="" height="68" class="mb-5">
		<p class="center mb-5">
			Gracias {{ fullName }}, <span class="span-text">por ser parte de</span> MIBODEGA.
		</p>
		<v-layout row wrap align-center class="wrapper-btns mb-4">
			<div>
				<a
					:href="linkAdmin"
					class="link"
					target="_blank"
				>
					Ir al administrador
				</a>
			</div>
			<div>
				<a
					:href="linkPayment"
					class="link"
					:target="isPeru ? '_blank' : ''"
				>
					Realizar pago
				</a>
			</div>
			<div>
				<a :href="linkGooglePlay" target="_blank">
					<img 
						:src="`${$S3}icon-google.png`" 
						alt="google play"
						class="btn-google-play"
						height="106"
					/>
				</a>
			</div>
		</v-layout>
	</div>
</template>
<script>
function created() {
	this.linkPayment = this.isPeru ? process.env.LINK_PAYMENT : '#section-payment';
}

function data() {
	return {
		linkGooglePlay: process.env.LINK_GOOGLE_PLAY,
		linkPayment: '',
		linkAdmin: process.env.LINK_ADMIN,
	};
}

export default {
	name: 'section-success',
	created,
	data,
	props: {
		fullName: String,
	},
};
</script>
<style lang="scss" scoped>
	.center {
		text-align: center;
	}

	.wrapper-status {
		color: color(title-green);
		font-family: font(lato-regular);
		font-size: size(large36);
		font-weight: weight(w900);
		padding: 137px 0px 85px;
	}

	.wrapper-btns {
		display: flex;
		justify-content: center;
	}

	.link {
		background: color(green-link);
		border-radius: 7px;
		display: inline-block;
		color: color(title-green);
		font-family: font(lato-regular);
		font-size: size(medium23);
		font-weight: weight(w900);
		height: 72px;
		line-height: 50px;
		margin-right: 20px;
		padding: 8px;
		text-decoration: none;
		text-align: center;
		width: 253px;
	}

	.span-text {
		color: color(span-text);
	}

	.btn-google-play {
		margin-top: 8px;
		width: 253px;
	}
</style>


// WEBPACK FOOTER //
// src/components/generate-app/section-success.vue